<template>
  <Modal
    v-model="openForm"
    :title="'保存油箱信息 / ' + carNo"
    footer-hide
    width="700"
    height="400"
    @on-cancel="cliclCancelBtn"
  >
    <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
      <Row :gutter="16">
        <Col span="12">
          <FormItem label="空箱电阻" prop="emptyOhm">
            <InputNumber
              :min="0"
              v-model="item.emptyOhm"
              style="width: 100%"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="半箱电阻" prop="halfOhm">
            <InputNumber
              :min="0"
              v-model="item.halfOhm"
              style="width: 100%"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="满箱电阻" prop="fullOhm">
            <InputNumber
              :min="0"
              v-model="item.fullOhm"
              style="width: 100%"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="油针高度/mm" prop="needleHeight">
            <InputNumber
              :min="0"
              v-model="item.needleHeight"
              style="width: 100%"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="百公里油耗/L" prop="oilCphk">
            <InputNumber
              :min="0"
              v-model="item.oilCphk"
              style="width: 100%"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="油箱高度/mm" prop="tankHeight">
            <InputNumber
              :min="0"
              v-model="item.tankHeight"
              style="width: 100%"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="油箱体积/L" prop="tankVolume">
            <InputNumber
              :min="0"
              v-model="item.tankVolume"
              style="width: 100%"
            ></InputNumber>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="刻度值" prop="tankVolume">
            <table>
              <thead>
                <tr>
                  <td>电阻值</td>
                  <td>油量</td>
                  <td>操作</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x, index) in item.tankScaleList" :key="index">
                  <td>
                    <InputNumber :min="0" v-model="x.ratio"></InputNumber>
                  </td>
                  <td>
                    <InputNumber :min="0" v-model="x.value"></InputNumber>
                  </td>
                  <td><Button icon="md-close" @click="del(index)"></Button></td>
                </tr>
              </tbody>
            </table>
            <Button @click="add">新增刻度</Button>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="end">
        <Col span="24">
          <div class="btn-wrap">
            <Button @click="resetForm">重置表单</Button>
            <Button type="primary" @click="save('item')">提交表单</Button>
          </div>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      carNo: "",
      item: {
        emptyOhm: 0,
        fullOhm: 0,
        halfOhm: 0,
        id: 0,
        needleHeight: 0,
        oilCphk: 0,
        tankHeight: 0,
        tankVolume: 0,
        tankScaleList: [],
      },
      ruleValidate: {},
      columns: [
        {
          title: "电阻值",
          slot: "ratio",
        },
        {
          title: "油量",
          slot: "value",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
    };
  },
  methods: {
    reachData(v) {
      console.log(v);
      this.openForm = true;
      this.item.carId = v.carId;
      this.carNo = v.carNo;
      this.getData();
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
    },
    save(name) {
      console.log(this.item);
      this.$refs[name].validate((valid) => {
        if (valid) {
          axios({
            method: "post",
            url: axios.dm + "/car/saveTank",
            data: this.item,
          }).then((res) => {
            if (res) {
              this.openForm = false;
              //this.getList();
            }
          });
        }
      });
    },
    getData() {
      axios({
        method: "post",
        url: axios.dm + "/car/getTank",
        data: this.item,
      }).then((res) => {
        var data = res.data.data;
        this.item = data;
      });
    },
    del(index) {
      this.item.tankScaleList.splice(index, 1);
    },
    add() {
      var obj = {
        ratio: 0,
        value: 0,
      };
      this.item.tankScaleList.push(obj);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/information/carOilBox.vue